// components/Header.jsx
const Header = ({ title, subtitle, logo }) => {
  return (
    <header className="mb-8 text-center">
      <div className="flex flex-col items-center mb-4">
        <picture>
          <source srcSet="/aol-logo.webp" type="image/webp" />
          <img
            src={logo || '/aol-logo.jpeg'}
            alt="Art of Living Logo"
            className="h-32 w-auto mb-4"
            loading="eager" />
        </picture>
        <picture>
          <source srcSet="/teacher1.webp" type="image/webp" />
          <img
            src="/teacher1.jpg"
            alt="Vaishali Rathi ji"
            className="h-40 w-40 rounded-full object-cover shadow-lg"
            loading="lazy" />
        </picture>
      </div>
      <h1 className="text-2xl md:text-3xl font-bold text-blue-800 mb-2 px-2">
        {title}
      </h1>
      <h2 className="text-lg md:text-xl text-blue-600">
        {subtitle}
      </h2>
      <p className="mt-4 text-sm md:text-base text-gray-600 max-w-lg mx-auto px-4">
        Transform your child's intuitive abilities through specialized Art of Living programs.
      </p>
      <p className="text-sm md:text-base text-gray-600 italic px-4">Scroll down to find a date which is most suitable to you</p>

      <p className="text-sm md:text-base text-gray-600 px-4">
        For queries: <a href="tel:+919391034913" className="text-blue-600 hover:underline">9391034913</a>, <a href="tel:+919949648214" className="text-blue-600 hover:underline">9949648214</a>
      </p>
    </header>
  );
};

export default Header;